import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigationType, useSearchParams } from 'react-router-dom';

import { updateComponentSearch, type ComponentSearchState } from './searchState';

export function useComponentSearch(): [URLSearchParams, (patch: Partial<ComponentSearchState>) => void] {
  const [search, setSearch] = useSearchParams();
  const { key } = useLocation();
  const navigationType = useNavigationType();
  const [current, setCurrent] = useState(search);
  const latest = useRef(search);
  const pending = useRef(new Set<string>());

  useEffect(() => {
    const encoded = search.toString();
    if (navigationType === 'REPLACE' && pending.current.has(encoded)) {
      if (encoded === latest.current.toString()) pending.current.clear();
      else pending.current.delete(encoded);
      return;
    }
    pending.current.clear();
    latest.current = search;
    setCurrent(search);
  }, [key, search, navigationType]);

  const update = (patch: Partial<ComponentSearchState>) => {
    const next = updateComponentSearch(latest.current, patch);
    latest.current = next;
    pending.current.add(next.toString());
    setCurrent(next);
    setSearch(next, { replace: true });
  };

  return [current, update];
}
